import { LoginType } from "global/enums";

const ACTIVE_LOGIN_TYPE_KEY = "cpl-active-login-type";

export interface ISessionStore {
  get(key: string): string | null;
  set(key: string, value: string): void;
  remove(key: string): void;
}

class NamespacedStorage implements ISessionStore {
  constructor(
    private readonly backend: Storage,
    private readonly prefix: string
  ) {}

  get(key: string): string | null {
    return this.backend.getItem(this.prefix + key);
  }

  set(key: string, value: string): void {
    this.backend.setItem(this.prefix + key, value);
  }

  remove(key: string): void {
    this.backend.removeItem(this.prefix + key);
  }
}

export function getActiveLoginType(): LoginType {
  const stored = sessionStorage.getItem(ACTIVE_LOGIN_TYPE_KEY);
  return stored !== null ? (Number(stored) as LoginType) : LoginType.Normal;
}

export function setActiveLoginType(loginType: LoginType): void {
  sessionStorage.setItem(ACTIVE_LOGIN_TYPE_KEY, String(loginType));
}

export function clearActiveLoginType(): void {
  sessionStorage.removeItem(ACTIVE_LOGIN_TYPE_KEY);
}

export function sessionStoreFor(loginType: LoginType): ISessionStore {
  switch (loginType) {
    case LoginType.Normal:
      return new NamespacedStorage(localStorage, "");
    case LoginType.Impersonation:
      return new NamespacedStorage(sessionStorage, "imp:");
    case LoginType.ExternalAccess:
      return new NamespacedStorage(sessionStorage, "ext:");
  }
}
